import React from "react";
import {useFetchUserWhoamiQuery} from "../../store";
import {LoadingItem} from "../loading-item/LoadingItem";
import {CircularProgress} from "@mui/material";

interface AppDataLoaderProps {
    children: React.ReactNode;
}

const AppDataLoader = ({children}: AppDataLoaderProps) => {
    const {isFetching: isFetchingUserWhoami} = useFetchUserWhoamiQuery(null);

    if (isFetchingUserWhoami) {
        return <LoadingItem><CircularProgress/></LoadingItem>;
    }

    return <>{children}</>;
};

export default AppDataLoader;